import { CheckCircle2, XCircle, Clock } from 'lucide-react';

export const LEAVE_STATUS = {
  pending: { label: 'En attente', className: 'bg-amber-100 text-amber-800 border-amber-200', icon: Clock },
  approved: { label: 'Approuvée', className: 'bg-emerald-100 text-emerald-800 border-emerald-200', icon: CheckCircle2 },
  rejected: { label: 'Refusée', className: 'bg-rose-100 text-rose-800 border-rose-200', icon: XCircle },
  cancelled: { label: 'Annulée', className: 'bg-gray-100 text-gray-700 border-gray-200', icon: XCircle },
};

export const LEAVE_TYPES = {
  leave: 'Congés',
  advance_day: 'Journée en avance',
  absence: 'Absence',
  other: 'Autre demande',
};
